import Vue from 'vue'
import App from './App'
import router from './router'
import store from './store'
// 防止重复点击   截流 防抖
import debounce from '@/utils/debounce.js'
import ElementUI from 'element-ui';
import xlsx from 'xlsx'
import requests from '@/utils/request'
import SIdentify from '@/components/page/identify'
import 'element-ui/lib/theme-chalk/index.css';
import showToast from '@/utils/showToast.js'
import util from '@/utils/util.js'
import { VueBus } from './plugins/vue-bus'

// 视频插件
import VideoPlayer from 'vue-video-player'
require('video.js/dist/video-js.css')
require('vue-video-player/src/custom-theme.css')
Vue.use(VideoPlayer)




Vue.prototype.$util = util
Vue.prototype.$ajax = requests
Vue.config.productionTip = false
Vue.prototype.$debounce = debounce
Vue.prototype.$showToast = showToast
Vue.prototype.$xlsx = xlsx
Vue.use(VueBus)
// 把vuex定义成全局组件
Vue.prototype.$store = store
Vue.use(SIdentify)
Vue.use(ElementUI);
/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  components: { App },
  template: '<App/>',
  data: {

  }
})

router.beforeEach((to, from, next) => {
  /* 路由发生变化修改页面title */
  if (to.meta.title) {
    document.title = to.meta.title
  }
  next()
})

// rem换算
function setRem() {
  var whdef = 100 / 1920; // 表示1920的设计图,使用100PX的默认值
  var bodyWidth = document.body.clientWidth; // 当前窗口的宽度
  var rem = bodyWidth * whdef; // 以默认比例值乘以当前窗口宽度,得到该宽度下的相应FONT-SIZE值
  document.getElementsByTagName('html')[0].style.fontSize = rem + 'px';
}
window.addEventListener('load', setRem);
window.addEventListener('resize', setRem);


// function receiveMessageFromIframePage(event) {
//   if (event.data.data) {
//     if (event.data.data.includes('backHome')) {
//       router.push({ name: 'home' })
//     } else if (event.data.data.includes('iframeNOlogin')) {
//       router.push({ name: 'login' })
//     }
//   }

// }
// window.addEventListener("message", receiveMessageFromIframePage, false);



// WEBPACK FOOTER //
// ./src/main.js